import React, { useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import UploadMultiPDF from "../api/upload/UploadMultiPDF.js";
import sendHS1 from "../api/sign/sendHS1.js";
import { useSnackbar } from "notistack";
import HS2 from "./HS2.js";
import { getDocument } from "pdfjs-dist";
import Modal1 from "../modals/Modal1";
import Space from "../layout/Space.js";
import downloadFile from "../api/download/downloadFile.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { getDocDataByRef } from "../models/DataFunctions.js";

const Sign = ({
  document,
  folder,
  orgData,
  userData,
  onClose,
  overrideId,
  navigateWorkspace,
  prefix,
}) => {
  const [step, setStep] = useState("choice");

  const [allfields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [path, setPath] = useState("");
  const [url, setUrl] = useState("");
  const [champs, setChamps] = useState([]);

  const handleOpenSign = () => {
    setStep("sign");
    setOpen2(true);
  };
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleDownload = async () => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "doc", document.id, folder.id, prefix, null);
    let new_document = await getDocDataByRef(document.ref);
    let filename = "ATH_vierge_" + folder.nom.replace(" ", "_") + ".pdf";
    downloadFile(new_document.files[0], filename);
    handleClickVariant("Document téléchargé avec succès", "success");
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const getPDFDimensions = async (pdfUrl) => {
    try {
      const loadingTask = getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      if (!pdf) {
        console.error("PDF document is null");
        return { width: 595, height: 842 }; // Default A4 dimensions
      }

      const page = await pdf.getPage(1);

      if (!page) {
        console.error("PDF page is null");
        return { width: 595, height: 842 }; // Default A4 dimensions
      }

      const viewport = page.getViewport({ scale: 1 });

      const width = viewport.width;
      const height = viewport.height;

      return { width, height };
    } catch (error) {
      console.error("Error getting PDF dimensions:", error);
      return { width: 595, height: 842 }; // Default A4 dimensions
    }
  };

  const handleSign = async () => {
    const url = document.files[-1].url;
    const token = await getOrRefreshFirebaseToken();
    const folderId = folder.id;
    const { width, height } = await getPDFDimensions(url);
    const res = await sendHS1(
      champs,
      url,
      token,
      folderId,
      document.id,
      "",
      height,
      width
    );
    handleClickVariant("Attestation signée avec succès", "success");
    onClose();
  };

  return (
    <>
      {step === "choice" && (
        <div className="flex flex-col p-3 gap-2  bg-neutral-100 rounded-xl">
          <>
            <div className="items-start w-c300 rounded-xl p-3 gap-2 bg-blue-100 flex flex-col">
              <div className="flex flex-row items-center gap-2">
                <div className="flex flex-col gap-1 items-start">
                  <div className="text-black text-h2">
                    Signer l'attestation{" "}
                  </div>

                  <div className="text-h3 items-start flex flex-row text-left text-shadow_50">
                    Remplissez les champs de signature et signez facilement
                  </div>
                </div>{" "}
              </div>{" "}
              <SecondaryButton
                onClick={handleOpenSign}
                className="items-start w-full"
              >
                <div className="flex flex-row items-center gap-2">
                  <div className="text-black text-h2">Signer l'attestation</div>
                </div>
              </SecondaryButton>
            </div>
            <div className="text-h3 items-center justify-center w-full text-center">
              ou
            </div>
            <div className="items-start rounded-xl p-3 w-c300 gap-2 flex flex-col bg-blue-100">
              <div className="flex flex-row items-center gap-2">
                <div className="flex flex-col gap-1 items-start w-fit">
                  <div className="text-black text-h2">
                    Joindre un document signé
                  </div>

                  <div className="text-h3 items-start flex flex-row text-left text-shadow_50">
                    Téléchargez déjà l'attestation vierge
                  </div>
                  <SecondaryButton onClick={handleDownload}>
                    Télécharger
                  </SecondaryButton>
                  <Space y={10} />

                  <div className="text-h3 items-start flex flex-row text-left text-shadow_50 w-c300">
                    Déposez ensuite ici le document que vous avez signé de votre
                    côté
                  </div>
                  <div className="w-fit mt-2">
                    <UploadMultiPDF
                      folder={folder}
                      docId={document.id}
                      onUpdate={onClose}
                      large={true}
                      width={"275px"}
                      height={"100px"}
                    />
                  </div>
                </div>{" "}
              </div>
            </div>
          </>
        </div>
      )}

      {step === "sign" && (
        <div className="flex flex-col items-center justify-center h-screen w-screen">
          <Modal1 isOpen={open2} onClose={handleClose2}>
            <HS2
              userData={userData}
              document={document}
              folder={folder}
              orgData={orgData}
              onClose={onClose}
              overrideId={overrideId}
              navigateWorkspace={navigateWorkspace}
            />
          </Modal1>
        </div>
      )}
    </>
  );
};

export default Sign;
